/**
 * Page-shaped loading placeholder for the PDF viewer region: a white "page
 * ghost" with pulsing text bars, centered on the same muted background the
 * real viewer uses. Shown from document selection until the first page canvas
 * paints, so the load reads as one phase with a stable layout (no spinner
 * swap, no layout shift when the page lands in the same spot).
 *
 * Kept in its own module (not inside the lazy PDFEditor chunk) so
 * CaseEditorPage can also render it synchronously as the Suspense fallback
 * while the editor chunk itself downloads.
 */
export function PdfPageSkeleton() {
  return (
    <div
      className="flex h-full w-full items-center justify-center bg-muted p-8"
      aria-busy="true"
      aria-label="Loading document"
    >
      {/* A4 portrait ghost sized by the available height so it fits without
          scrolling; width follows from the aspect ratio. */}
      <div className="h-[85%] max-w-full aspect-[1/1.414] bg-white rounded-md shadow-sm p-[8%] overflow-hidden">
        <div className="flex flex-col gap-[4%] h-full animate-pulse motion-reduce:animate-none">
          <div className="h-[3.5%] w-2/5 rounded bg-muted" />
          <div className="h-[2.5%] w-full rounded bg-muted" />
          <div className="h-[2.5%] w-full rounded bg-muted" />
          <div className="h-[2.5%] w-4/5 rounded bg-muted" />
          <div className="h-[2.5%] w-full rounded bg-muted" />
          <div className="h-[2.5%] w-3/5 rounded bg-muted" />
          <div className="h-[3.5%] w-1/3 rounded bg-muted mt-[4%]" />
          <div className="h-[2.5%] w-full rounded bg-muted" />
          <div className="h-[2.5%] w-11/12 rounded bg-muted" />
          <div className="h-[2.5%] w-full rounded bg-muted" />
          <div className="h-[2.5%] w-2/3 rounded bg-muted" />
        </div>
      </div>
    </div>
  );
}
